import { getStoreState } from 'config/store'
import { getCampaignIdFromInteractionId } from 'modules/embed/utils'
import { getMessageAttribute } from 'modules/message/utils'
import { pathOr } from 'ramda'
import { EmbedCampaign } from 'types/embed'
import { Message } from 'types/message'

export const getCampaignIdFromMessage = (message?: Message): number => {
  if (message) {
    const campaignId = getMessageAttribute(message, 'campaignId')
    if (campaignId) {
      return campaignId
    }

    const interactionId = getMessageAttribute(message, 'interactionId') || getMessageAttribute(message, 'startInteraction')
    if (!!interactionId) {
      return getCampaignIdFromInteractionId(interactionId)
    }
  }
  return null
}

export const getAttributeFromCampaignOrDefault = (campaign: EmbedCampaign, path: string[], defaultValue = null) => {
  return pathOr(defaultValue, ['attributes', ...path], campaign)
}

export const getCampaignFromEmbedById = (campaignId: number) => {
  const campaigns = pathOr([], ['embed', 'configuration', 'campaigns'], getStoreState())
  return campaigns.filter(campaign => campaign.id === campaignId)[0]
}

